import Footer from "../components/Footer";
import HeroPages from "../components/HeroPages";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useState } from 'react';
function Contact() {
  const [firstName, setFirstName] = useState(''); 
  const [mobile, setMobile] = useState(''); 
  const [pickUp, setPickUp] = useState(''); 
  const [drop, setDrop] = useState(''); 
  const sendNow =async()=>{
    
    let msg="Hello admin, i am "+firstName+" looking for cab booking on from "+pickUp+" To "+drop;
    //alert("msg:"+msg);
    window.location.href ="https://api.whatsapp.com/send?phone=919324064780&text="+msg;
  }
  return (
    <>
      <section className="contact-page">
        <HeroPages name="Contact" />
        <div className="container">
          <div className="contact-div">
            <div className="contact-div__text">
              <h2>Need additional information?</h2>
              <p>
                A multifaceted professional skilled in multiple fields of
                research, development as well as a learning specialist. Over 15
                years of experience.
              </p>
              <a href="tel:+91 9324064780">
              <i className="fa fa-phone"></i>&nbsp; +91 9324064780
              </a>
              <a href="/">
              <i className="fa fa-square-envelope"></i>&nbsp;
              sairamcab4861@gmail.com
              </a>
              <a href="/">
                <i className="fa fa-location-dot"></i>&nbsp; Chanakya Lok Bharti CHS Ltd Marol Maroshi Road Andheri east 400059
              </a>
            </div>
            <div className="contact-div__form">
              <form>
                <label>
                  Full Name <b>*</b>
                </label>
                <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} placeholder='Please enter name'></input>
                <label>
                  Mobile No <b>*</b>
                </label>
                <input type="text" value={mobile}  onChange={e => setMobile(e.target.value)} placeholder="Please enter mobile"></input>

                <label>
                  Pick up <b>*</b>
                </label>
                <input type="text" value={pickUp} onChange={e => setPickUp(e.target.value)} placeholder='Please enter pickup location'></input>
                <label>
                  Drop  <b>*</b>
                </label>
                <input type="text" value={drop} onChange={e => setDrop(e.target.value)} placeholder='Please enter drop location'></input>

                <button type="button" onClick={sendNow}>
                  <i className="fa fa-envelope-open-text"></i>&nbsp; Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
        <div className="book-banner">
          <div className="book-banner__overlay"></div>
          <div className="container">
            <div className="text-content">
              <h2>Book a car by getting in touch with us</h2>
              <span>
                <a href="tel:+91 9324064780">
                  <i className="fa fa-phone"></i>
                  <h3>+91 9324064780</h3>
                </a>
              </span>
            </div>
          </div>
        </div>
        <Footer />
      </section>
    </>
  );
}

export default Contact;
